import React from 'react';
import { Box, Button } from '@mui/material';
import { useLang } from '~/hooks/useLang';

interface StepActionsProps {
  readonly index: number;
  readonly getBasicInfoValidity: () => boolean;
  readonly getManagersValidity: () => boolean;
  readonly handleNext: () => void;
  readonly handleBack: () => void;
}

export default function StepActions({ 
  handleNext, 
  handleBack, 
  index,
  getBasicInfoValidity,
  getManagersValidity,
}: StepActionsProps) {
  const { translate } = useLang();
  const isLastStep = index === 2; // Temos 3 steps (0, 1, 2)
  const isFirstStep = index === 0;

  const isNextButtonDisabled = (): boolean => {
    if (index === 0) {
      return !getBasicInfoValidity();
    }
    if (index === 1) {
      return !getManagersValidity();
    }
    return false;
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Button
        disabled={isFirstStep}
        onClick={handleBack}
        sx={{ mt: 1, mr: 1 }}
      >
        {translate('Back')}
      </Button>
      <Button
        variant="contained"
        disabled={isNextButtonDisabled()}
        onClick={handleNext}
        sx={{ mt: 1, mr: 1 }}
      >
        {translate(isLastStep ? 'Finish' : 'Continue')}
      </Button>
    </Box>
  );
}
